import React, { useContext } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AccordionContext } from 'react-bootstrap'
import palette from 'src/designSystem/variables/palette'
import { TrusteroBeaker } from 'src/pages/ReportScan/ReportScan.styles'
import { TextButton } from 'src/components/Reusable/Buttons/TextButton'
import { ReactComponent as DeleteIcon } from '../../../../Icons/assets/delete-icon.svg'
import { ReactComponent as EvidenceIcon } from '../../../../Icons/ShowPageAccordions/evidence.svg'
import { ReactComponent as TestIcon } from '../../../../Icons/ShowPageAccordions/test.svg'
import { ShowPageAccordionIcon } from '../ShowPageAccordions.styles'
import { ShowPageAccordionIconOld } from '../ShowPageAccordions.components'

export const SubsectionAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
  > .accordion-item,
  > .accordion-item:not(:first-of-type) {
    overflow: hidden;
    border-radius: 14px;
    border: 1px solid ${palette.neutral[100]};
  }
  width: 100%;
`

export const SubsectionDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-top: 8px;

  > :nth-child(1) {
    flex: 1;
  }

  > :nth-child(2) {
    flex: 1;
  }

  > .accordion-item,
  > .accordion-item:not(:first-of-type) {
    overflow: hidden;
    border-radius: 14px;
    border: 1px solid ${palette.neutral[100]};
  }
`

export const SubsectionAccordionHeaderContent = styled.div<{
  $alignTop?: boolean
}>`
  display: flex;
  align-items: ${({ $alignTop }) => ($alignTop ? 'flex-start' : 'center')};
  justify-content: space-between;
  width: 100%;
`

export const SubsectionAccordionHeader = styled(Accordion.Header).attrs(
  (props) => {
    const { activeEventKey } = useContext(AccordionContext)
    const isActive: boolean = Array.isArray(activeEventKey)
      ? activeEventKey?.includes(props.$currentEventKey) ?? false
      : Number(activeEventKey) === Number(props.$currentEventKey)
    return {
      forwardedAs: 'header',
      $isActive: isActive,
      children: (
        <SubsectionAccordionHeaderContent $alignTop={props.$alignTop}>
          {props.children}
          {props.$headerActions && (
            <div className="subsection-header-actions">
              {props.$headerActions}
            </div>
          )}
          <ShowPageAccordionIcon isActive={isActive} />
        </SubsectionAccordionHeaderContent>
      ),
    }
  },
)<{
  $currentEventKey: string
  $isActive?: boolean
  $noBottomBorder?: boolean
  $alignTop?: boolean
  $headerActions?: JSX.Element
}>`
  width: 100%;
  .accordion-button {
    font-size: 16px;
    padding: 10px 24px;
    color: ${palette.neutral[900]};
    display: flex;
    align-items: ${({ $alignTop }) => ($alignTop ? 'flex-start' : 'center')};
    justify-content: space-between;
    border-bottom: ${({ $isActive }) =>
      $isActive ? `1px solid ${palette.neutral[100]}` : 'none'};
    width: 100%;
    ${({ $noBottomBorder }) => $noBottomBorder && 'border-bottom: none;'}
    :focus,
    :hover,
    :not(.collapsed) {
      outline: none;
      background-color: unset;
      box-shadow: none;
    }

    ::after {
      display: none;
    }
  }
`
export const SubsectionAccordionHeaderOld = styled(Accordion.Header).attrs(
  (props) => {
    const { activeEventKey } = useContext(AccordionContext)
    const isActive: boolean = Array.isArray(activeEventKey)
      ? activeEventKey?.includes(props.$currentEventKey) ?? false
      : Number(activeEventKey) === Number(props.$currentEventKey)
    return {
      forwardedAs: 'header',
      children: (
        <>
          {props.children}
          <ShowPageAccordionIconOld
            isActive={isActive}
            isDisabled={props.disabled}
          />
        </>
      ),
    }
  },
)<{ $currentEventKey: string }>`
  .accordion-button {
    font-size: 16px;
    gap: 12px;
    padding: 10px 24px;
    color: ${palette.neutral[900]};

    :focus,
    :hover,
    :not(.collapsed) {
      outline: none;
      background-color: unset;
      box-shadow: none;
    }

    ::after {
      display: none;
    }
  }
`

export const SubsectionAccordionFooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 1em 1em 0;
`

export const DismissContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const AccordionDismissBtn = styled(TextButton)`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AnswerAgainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
`

export const AccordionAnswerAgainBtn = styled(TextButton)`
  margin-right: 2em;
  color: ${palette.purple[400]};
`

export const SubsectionAccordionBody = styled(Accordion.Body)`
  padding: 8px 1.5rem 0.5rem;
`

export const SubsectionAccordionHeaderGrid = styled.div<{
  $customGridLayout?: string
  $alignTop?: boolean
}>`
  display: grid;
  width: 100%;
  gap: 8px;
  align-items: ${({ $alignTop }) => ($alignTop ? 'flex-start' : 'center')};
  ${({ $customGridLayout }) =>
    `grid-template-columns: ${
      $customGridLayout ? $customGridLayout : `max-content 1fr 2fr max-content`
    }`};
`

export const SubsectionAccordionDismissIcon = styled(DeleteIcon)``

export const SubsectionAccordionHeaderNote = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 300;
`

export const SubsectionAccordionBeakerIcon = styled(TrusteroBeaker)`
  font-size: 12px;
`

export const StyledSubsectionAccordionIcon = styled(FontAwesomeIcon)`
  font-size: 18px;
  color: ${palette.neutral[600]};
  font-weight: 900;
`

export const SmallStyledSubsectionAccordionIcon = styled(FontAwesomeIcon)<{
  $isRefresh?: boolean
}>`
  font-size: 14px;
  color: ${({ $isRefresh }) =>
    $isRefresh ? palette.purple[400] : palette.neutral[600]};
  font-weight: 900;
  margin-right: 4px;
`

export const SubsectionAccordionEvidenceIcon = styled(EvidenceIcon)`
  font-size: 18px;
  color: ${palette.neutral[600]};
  font-weight: 900;
`
export const SubsectionAccordionTestIcon = styled(TestIcon)`
  font-size: 18px;
  color: ${palette.neutral[600]};
  font-weight: 900;
`

export const SubSectionAccordionHeaderIconContainer = styled.div`
  display: flex;
  align-items: center;
`
export const SubSectionAccordionHeaderTitleContainer = styled.div`
  word-wrap: break-word;
  max-width: 100%;
`

export const StyledAccordionItem = styled(Accordion.Item)`
  display: flex;
  flex-direction: column;

  .subsection-header-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.12s ease-in-out;
  }

  &:hover .subsection-header-actions,
  &:focus-within .subsection-header-actions {
    opacity: 1;
    pointer-events: auto;
  }

  > :nth-child(3) {
    margin-top: auto;
  }
`
